'use strict';

let requireOrNull = require;
if (!process.env.WEBPACK) {
  requireOrNull = str => str;
}

const critModules = [
  {
    name: 'BuyButtonForm',
    module: requireOrNull(
      '../../../../modules/buy_button_form/frontend/desktop'
    ),
    featureCheck: serverObj => serverObj.usesBuyButtonForm,
  },
  {
    name: 'Juice',
    module: requireOrNull(
      '../../../../modules/juice_program/frontend/juice_program'
    ),
    featureCheck: serverObj =>
      serverObj.juiceProgramInfo &&
      serverObj.juiceProgramInfo.isJuiceProgramEnabled,
  },
  {
    name: 'CashBack',
    module: requireOrNull(
      '../../../../modules/cash_back/desktop_2016/frontend/cash_back'
    ),
    featureCheck: serverObj => serverObj.cashBack,
  },
  {
    name: 'Cart',
    module: requireOrNull('../../../../modules/cart/frontend/index'),
    featureCheck: serverObj => serverObj.cart,
  },
  {
    name: 'FinePrint',
    module: requireOrNull('../../../../modules/fine_print/frontend'),
    featureCheck: serverObj => serverObj.usesBuyButtonForm,
  },
];

const nonCritModules = [
  {
    name: 'AsyncScripts',
    module: requireOrNull('../async_scripts/local'),
  },
  {
    name: 'Merchant',
    module: requireOrNull('../../../../modules/merchant/frontend/lazy_load'),
    featureCheck: serverObj =>
      !serverObj.merchantV2 &&
      serverObj.merchant &&
      serverObj.merchant.clientSideMerchantLocations &&
      serverObj.loadSwitch &&
      serverObj.loadSwitch.shouldLoadLazyLoadMerchantLocations,
  },
  {
    name: 'Value Proposition',
    module: requireOrNull('../../../../modules/value_proposition/frontend'),
    featureCheck: serverObj => serverObj.valueProposition,
  },
  {
    name: 'PurchaseCreditsMessage',
    module: requireOrNull(
      '../../../../modules/purchase_credits/frontend/purchase_credits_message'
    ),
    featureCheck: serverObj => serverObj.validPurchaseCreditsDeal,
  },
];

module.exports = { critModules, nonCritModules };
